module.exports = __webpack_public_path__ + "static/media/10.5ff00bb2.JPG";